import React, { useState } from 'react';
import { DatePicker } from 'rsuite';
import { edit_sample_receiver_schedule } from '../utilis/sampleReceiverServices';
import { useSelector } from 'react-redux';
import { get_selected_plant_name } from '../../../redux/auth/auth.selectors';
import getErrorMessage from '../../../util';
import SnackbarWithMessage from '../../../common/components/Snackbars/SnackbarWithMessage';
import { Portal } from '@mui/material';

export const CustomReceiverDatePicker = (params) => {
    const { selected_plant } = useSelector(get_selected_plant_name);
    // Check if value is truthy and represents a valid date
    const { value, row, id, field, api, ...otherProps } = params;
    const [open_snackbar_with_message, set_open_snackbar_with_message] = useState({
        open: false,
        message: "",
        severity: "info"
    });
    // console.log(row);
    const handleDatePickerChange = async (newValue) => {
        try {
            const material_type = (() => {
                switch (row.sample_type) {
                    case "SFG(without micro)":
                        return "INTM";
                    case "SFG(with micro)":
                        return "INTM";
                    case "FP(without micro)":
                        return "FP";
                    case "FP(with micro)":
                        return "FP";
                    case "CB(urgent)":
                        return "CB";
                    case "CB(additional)":
                        return "CB";
                    case "CB":
                        return "CB";
                    default:
                        return row.sample_type;
                }
            })();
            const updatedRow = {
                ...row,
                receiving_date_by_qc: newValue,
            };
            const result = await edit_sample_receiver_schedule(
                updatedRow,
                material_type,
                set_open_snackbar_with_message,
            );
            if (result) {
                api.setEditCellValue({ id, field, value: newValue });
            }
        } catch (error) {
            console.log(error);
            set_open_snackbar_with_message({
                message: error?.response?.data?.error,
                open: true,
                severity: "error"
            });
        }
    };
    return (
        <div style={{
            minWidth: "200px"
        }}>
            <Portal>
                <SnackbarWithMessage {...open_snackbar_with_message} onClose={() => {
                    set_open_snackbar_with_message({
                        open: false,
                        message: "",
                        severity: "info"
                    });
                }} />
            </Portal>
            <DatePicker
                format="yyyy-MM-dd HH:mm"
                placement={"auto"}
                disabled={(selected_plant === "sunpharma_dewas_sterile_API" && row?.["storage_condition"] === "") ? true : false}
                value={value}
                cleanable={false}
                placeholder={"YYYY-MM-DD hh:mm"}
                onChange={handleDatePickerChange}
                {...otherProps}

            />
        </div>
    );
};
